// Vuex connections module mutations types
export const FILL_LIST = 'FILL_LIST';
export const SET_PAGE = 'SET_PAGE';
